/* eslint-disable quotes */
/* eslint-disable no-multi-str */
/* eslint-disable camelcase */
/* eslint-disable */
import * as pc from "playcanvas";
import gsap from "gsap";
import { MouseManager } from "./MouseManager";
import { MaterialManager } from "./MaterialManager";

// User Components
import { UserComponentManager } from "./components/UserComponentManager";
import { UI } from "./UI";
import { LandingPageScene } from "./LandingPageScene";
import { ClockScene } from "./ClockScene";
import { PlantScene } from "./PlantScene";

// State machine
import { FSM } from "./fsm/FSM";
import { FSM_INIT } from "./fsm/FSM_INIT";
import { FSM_LOAD_PLANT } from "./fsm/FSM_PLANT";

import { IRWNCamera } from "./IRWNCamera";
import { AudioManager } from "./AudioManager";
import { AssetLoader } from "./AssetLoader";
import { FSM_LOAD_LANDING } from "./fsm/FSM_LANDING";
import { CreatureManager } from "./CreatureManager";
import { FSM_CLOCK } from "./fsm/FSM_CLOCK";
import { SceneSwitcher } from "./SceneSwitcher";
import * as svgLoader from "external-svg-loader";
import AxL from "../axl";
import Debugger from "../debugger/Debugger";

////////////////////////////////////////////////////////////////
// TOP LEVEL - Manages Playcanvas Application
////////////////////////////////////////////////////////////////
export const IRWN = {
  isNight: false,
  aspectSqueezeScalar_landingPage: 2.6,
  aspectSqueezeScalar: 2.2,
  depthSqueeze: 0.02,
  welcomeMessage_minumumUserCount: 10,

  palette: {
    white: { r: 0.91372549, g: 0.89803922, b: 0.89411765 },
    loaderYellow: { r: 0.8, g: 0.77647059, b: 0.6745098 },
    blue: { r: 0.04313725, g: 0.13333333, b: 0.25490196 },
    grey: { r: 0.86666667, g: 0.84705882, b: 0.83529412 },
  },

  init: function (axl) {
    this.axl = axl;
    this.currentPlantID = "";
    this.previousHour = -1;
    this.currentHour = -1;
    this.currentSceneIndex = -1;
    IRWN.infoActive = false;
    this.setupPlayCanvas();
    this.resizeHandler();
    this.activateUI();

    document
      .getElementById("btn_audio")
      .addEventListener("click", this.onMuteBtnClicked.bind(this));
    document
      .getElementById("btn_share")
      .addEventListener("click", this.onShareBtnClicked);

    const info_links = Array.from(document.getElementsByClassName("ext_link"));
    info_links.forEach((link) => {
      link.addEventListener("click", () => {
        // this.debugger.log(`click : ${link.href}`);
        axl.sendMessage(AxL.ChildToHost.NAVIGATE, link.href);
      });
    });

    const nightCheck = new Date();
    const hrs = nightCheck.getHours();
    IRWN.isNight = hrs < 8 || hrs >= 20;
    this.firstSceneLoad = true;
    this.sceneSwitcherEnabled = false;
    this.sceneSwitcherClickReady = false;
    FSM.setState(FSM_INIT);
  },
  setupPlayCanvas: function () {
    //------------------------------------> HTML / WebGL setup
    const canvas = document.getElementById("irwn_app");
    const pcApp = (this.playcanvasApp = new pc.Application(canvas, {
      mouse: new pc.Mouse(document.body),
      touch: new pc.TouchDevice(document.body),
      elementInput: new pc.ElementInput(canvas),
      resolutionMode: pc.RESOLUTION_AUTO,
    }));
    this.pcApp = pcApp;

    const audioContext = pcApp.systems.sound.context;
    // if the sound is on by default
    // any click in the viewport is going to unmute it
    // if the user clicks the mute button, the sound gets muted and unmuted immediately
    // this way the first click is not going to happen since we're introducing a delay
    audioContext.addEventListener('statechange', () => {
      this.updateAudioButtonState(true);
      setTimeout(() => {
        IRWN.viewportClicked = true;
      }, 350)
    });
    IRWN.audioEnabled = true;
    IRWN.viewportClicked = false;
    pcApp.setCanvasFillMode(pc.FILLMODE_FILL_WINDOW);
    pcApp.setCanvasResolution(pc.RESOLUTION_AUTO);
    // Window resize handler
    window.addEventListener("resize", (evt) => IRWN.resizeHandler(evt));
    pcApp.graphicsDevice.maxPixelRatio = this.getDevicePixelRatio();

    //------------------------------------> Lighting / tone
    pcApp.scene.ambientLight.color = new pc.Color(0.2, 0.2, 0.2);
    pcApp.scene.ambientLight.intensity = 0.95;
    pcApp.scene.ambientLight.gammaCorrection = pc.GAMMA_SRGB;
    this.resizeHandler();
    pcApp.updateCanvasSize();

    pc.basisInitialize({
      glueUrl: "basis/basis.wasm.js",
      wasmUrl: "basis/basis.wasm.wasm",
      fallbackUrl: "basis//basis.js",
    });

    //------------------------------------> Init Managers and scene objects
    AssetLoader.init(pcApp);
    MaterialManager.init(pcApp);
    AudioManager.init(pcApp);
    MouseManager.init(pcApp);
    UI.init(pcApp);
    LandingPageScene.init(pcApp);
    ClockScene.init(pcApp);
    PlantScene.init(pcApp);
    SceneSwitcher.init(pcApp);

    //------------------------------------> CAMERA
    this.e_camera = new pc.Entity("camera");
    this.cam = this.e_camera.addComponent("camera", {});
    this.setBackgroundColour(IRWN.palette.white);
    this.e_camera.addComponent("audiolistener");
    pcApp.root.addChild(this.e_camera);
    this.e_camera.setPosition(0, 0, 7);

    // Set update loop
    pcApp.start();
  },
  activateUI: function () {
    // Setup input events
    document.getElementById("btn_info").style.pointerEvents = "all";
    // setup EXIT button handler
    document.getElementById("btn_info").addEventListener("click", function () {
      IRWN.toggleInfo();
    });
    // setup share option
    // document.getElementById("btn_share").addEventListener("click", () => {
    //   this.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {
    //     currentScene: IRWN.currentSceneIndex,
    //   });
    //   this.axl.sendMessage(AxL.ChildToHost.SHARE, {
    //     title: "SHARE TEXT (to be updated)",
    //   });
    // });
  },
  update: function (dt) {
    MouseManager.update(dt);
    FSM.update(dt);
    AudioManager.update(dt);
    MaterialManager.updateTurbulance(dt);
    UserComponentManager.update(dt);
    IRWNCamera.update(dt);

    if (this.currentHour !== -1) {
      const d = new Date();
      this.currentHour = d.getHours();
      if (this.currentHour !== this.previousHour) {
        if (this.currentHour <= 20 && this.currentHour >= 8) {
          console.log(
            "Hour changed from " +
              this.previousHour +
              "  to  " +
              this.currentHour
          );
          FSM.setState(FSM_CLOCK);
          ClockScene.loadScene(this.getPlantForTime(this.currentHour));
        }
      }
      this.previousHour = this.currentHour;
    }
    // console.log(window.performance.memory);
  },
  resizeHandler: function () {
    this.playcanvasApp.resizeCanvas();
    this.playcanvasApp.updateCanvasSize();

    const pxRatio = this.getDevicePixelRatio();
    const body = document.body;
    const html = document.documentElement;

    this.appWidth =
      Math.max(
        body.scrollWidth,
        body.offsetWidth,
        html.clientWidth,
        html.scrollWidth,
        html.offsetWidth
      ) * pxRatio;
    this.appHeight =
      Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      ) * pxRatio;
    const squeeze =
      FSM.currentState == FSM_LOAD_LANDING
        ? this.aspectSqueezeScalar_landingPage
        : this.aspectSqueezeScalar;
    this.aspectSqueeze = this.appWidth / this.appHeight / squeeze;
    UI.resizeHandler(this.appWidth, this.appHeight, pxRatio);
    LandingPageScene.resizeHandler(this.appWidth, this.appHeight, pxRatio);
    ClockScene.resizeHandler(this.appWidth, this.appHeight, pxRatio);
    PlantScene.resizeHandler(this.appWidth, this.appHeight, pxRatio);
  },
  getfluidX: function (originX, z, min = -1000, max = 1000) {
    return pc.math.clamp(
      originX * (this.aspectSqueeze - z * IRWN.depthSqueeze),
      min,
      max
    );
  },
  loadCurrentScene: function () {
    const d = new Date();
    const targetSceneID = this.getPlantForTime(d.getHours(), d.getMinutes());
    this.previousHour = d.getHours();
    this.currentHour = d.getHours();
    this.loadScene(targetSceneID);
  },
  loadScene: function (id) {
    PlantScene.hide();
    this.unloadScene();
    console.log("loading scene:  " + id);
    this.currentPlantID = id;

    // Load JSON, then move on to FSM_GOTO_PLANT
    const jsonURL = "./json/plants/" + id + ".json";
    fetch(jsonURL)
      .then((response) => {
        return response.json();
      })
      .then((data) => this.onPlantJsonLoaded(data));
  },

  // Clear current scene from VRAM and reset all asset lists
  unloadScene: function () {
    PlantScene.unload();
    CreatureManager.flush();
    UserComponentManager.flush();
    AssetLoader.unloadPlantAssets();
  },
  unloadLandingPage: function () {},
  onPlantJsonLoaded: function (json) {
    this.currentPlantJson = json;
    FSM.setState(FSM_LOAD_PLANT);
  },
  loadAppJson: function () {
    // Load JSON, then move on to FSM_LOAD_CLOCK
    const jsonURL = "./json/irwn.json";
    fetch(jsonURL)
      .then((response) => {
        return response.json();
      })
      .then((json) => this.onJsonLoaded(json));
  },

  onJsonLoaded: function (json) {
    this.appJson = json;
    IRWNCamera.init(this.cam, this.e_camera, this.appJson.camera);
    this.playcanvasApp.on("update", (dt) => this.update(dt));
    FSM.setState(FSM_LOAD_LANDING);
  },

  getAppJson: function () {
    return this.appJson;
  },
  getPlantJson: function () {
    return this.currentPlantJson;
  },

  setBackgroundColour: function (r, g, b) {
    this.cam.clearColor = new pc.Color(r, g, b);
  },
  setBackgroundColour: function (col) {
    this.cam.clearColor = new pc.Color(col.r, col.g, col.b);
  },

  showInfo: function () {
    IRWN.infoActive = true;
    document.getElementById("overlay_info").style.pointerEvents = "all";
    document.getElementById("btn_info_exit").style.pointerEvents = "all";

    // blackout BG - close INFO on click
    document.getElementById("overlay_info_blackout").style.pointerEvents =
      "all";
    document
      .getElementById("overlay_info_blackout")
      .addEventListener("click", function () {
        IRWN.hideInfo();
      });

    // hide normal UI
    document.getElementById("btn_container").style.pointerEvents = "none";
    document.getElementById("btn_audio").style.pointerEvents = "none";
    gsap.killTweensOf(".btn_container");
    gsap.to(".btn_container", { opacity: "0%", duration: 0.25 });
    gsap.killTweensOf(".btn_audio");
    gsap.to(".btn_audio", { opacity: "0%", duration: 0.25 });

    // setup EXIT button handler
    document
      .getElementById("btn_info_exit")
      .addEventListener("click", function () {
        IRWN.hideInfo();
      });
    document.getElementById("btn_info_exit").style.pointerEvents = "all";
    gsap.killTweensOf(".btn_info_exit");
    gsap.to(".btn_info_exit", { opacity: "100%", duration: 0.5 });

    // reveal info popup elements
    gsap.killTweensOf(".overlay_info_blackout");
    gsap.killTweensOf(".overlay_info");
    gsap.killTweensOf(".overlay_info_header1");
    gsap.killTweensOf(".overlay_info_header2");
    gsap.killTweensOf(".overlay_info_subheader");
    gsap.killTweensOf(".overlay_info_body");

    // reveal blackout
    gsap.to(".overlay_info_blackout", { opacity: "100%", duration: 1 });
    // reveal white panel
    gsap.to(".overlay_info", { opacity: "100%", delay: 0.5, duration: 1 });
    // reveal headers
    gsap.to(".overlay_info_header1", {
      opacity: "100%",
      delay: 1.5,
      duration: 1.5,
    });
    gsap.to(".overlay_info_subheader", {
      opacity: "100%",
      delay: 1.5,
      duration: 1.5,
    });
    // reveal body
    gsap.to(".overlay_info_body", {
      opacity: "100%",
      delay: 1.5,
      duration: 1.5,
    });
  },
  hideInfo: function () {
    IRWN.infoActive = false;
    document.getElementById("overlay_info").style.pointerEvents = "none";
    document.getElementById("btn_info_exit").style.pointerEvents = "none";

    // blackout BG - remove mouse interactions
    document.getElementById("overlay_info_blackout").style.pointerEvents =
      "none";
    document
      .getElementById("overlay_info_blackout")
      .removeEventListener("click", function () {
        IRWN.hideInfo();
      });

    // show normal UI
    document.getElementById("btn_container").style.pointerEvents = "all";
    document.getElementById("btn_audio").style.pointerEvents = "all";
    gsap.killTweensOf(".btn_container");
    gsap.to(".btn_container", { opacity: "100%", duration: 0.5 });
    gsap.killTweensOf(".btn_audio");
    gsap.to(".btn_audio", { opacity: "100%", duration: 0.5 });

    // HIDE EXIT button
    document
      .getElementById("btn_info_exit")
      .addEventListener("click", function () {
        IRWN.hideInfo();
      });
    document.getElementById("btn_info_exit").style.pointerEvents = "none";
    gsap.killTweensOf(".btn_info_exit");
    gsap.to(".btn_info_exit", { opacity: "0%", duration: 0.25 });

    // hide info popup elements
    gsap.killTweensOf(".overlay_info_blackout");
    gsap.killTweensOf(".overlay_info");
    gsap.killTweensOf(".overlay_info_header1");
    gsap.killTweensOf(".overlay_info_header2");
    gsap.killTweensOf(".overlay_info_subheader");
    gsap.killTweensOf(".overlay_info_body");

    gsap.to(".overlay_info_blackout", { opacity: 0, duration: 1, delay: 0.5 });
    // reveal white panel
    gsap.to(".overlay_info", { opacity: 0, delay: 0.5, duration: 0.5 });
    // reveal headers
    gsap.to(".overlay_info_header1", {
      opacity: 0,
      duration: 0.3,
    });
    gsap.to(".overlay_info_subheader", {
      opacity: 0,
      duration: 0.3,
    });
    // reveal body
    gsap.to(".overlay_info_body", {
      opacity: 0,
      duration: 0.3,
    });
  },
  toggleInfo: function () {
    // IRWN.infoActive = !IRWN.infoActive;
    if (!IRWN.infoActive) {
      IRWN.showInfo();
      // analytics
      IRWN.analyticsReport("click_info_show", "info_show");
    } else {
      IRWN.hideInfo();
      // analytics
      IRWN.analyticsReport("click_info_hide", "info_hide");
    }
  },

  ///------------------------------------> Mute Button Logic
  onMuteBtnClicked: function() {
    if(IRWN.viewportClicked){
      if (this.pcApp.systems.sound.context.state === 'running') {
          IRWN.audioEnabled = !IRWN.audioEnabled;
        }
      if (IRWN.audioEnabled) {
          AudioManager.setMute(false);
          IRWN.analyticsReport("click_audio_on", "audio_on");
      } else {
          AudioManager.setMute(true);
          IRWN.analyticsReport("click_audio_off", "audio_off");
        }
    this.updateAudioButtonState(false);
    }
  },
  updateAudioButtonState() {
    const currentlyPlaying = IRWN.audioEnabled && this.pcApp.systems.sound.context.state === 'running';
    if (currentlyPlaying) {
      document.getElementById('btn_audio').classList.add('animated');
    } else {
      document.getElementById('btn_audio').classList.remove('animated');
    }
  },

  onShareBtnClicked: function () {
    IRWN.axl.sendMessage(AxL.ChildToHost.SHARE, {
      title: "Time to slow down with nature",
      // image here?
    });
  },

  getCurrentPlant: function() {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    return this.getPlantFromIndex(this.getSceneForTime(currentHour, currentMinute));
  },
  getSceneForTime: function(hrs, mins) {
    if (mins == 59) hrs = hrs + (1 % 24);

    // WARNING: make sure to update the getTimeForSceneStart function whenever you edit these
    // TODO: why not just store start and end times in each plant config (IRWN.plantConfigs) ?
    switch (hrs) {
      case 8: return 0;
      case 9: return 1;
      case 10: return 2;
      case 11: return 3;
      case 12: return 4;
      case 13: return 5;
      case 14: return 6;
      case 15: return 7;
      case 16: return 8;
      case 17: return 9;
      case 18: return 10;
      case 19: return 11;
      default: return 12;
    };
  },
  getTimeForSceneStart: function(sceneIdx) {
    // WARNING: make sure to update the getSceneForTime function whenever you edit these
    switch (sceneIdx) {
      case 0: return 8;
      case 1: return 9;
      case 2: return 10;
      case 3: return 11;
      case 4: return 12;
      case 5: return 13;
      case 6: return 14;
      case 7: return 15;
      case 8: return 16;
      case 9: return 17;
      case 10: return 18;
      case 11: return 19;
      case 12: return 20; // scene 12 is used from 20:00 to 07:00
      default: return null;
    }
  },
  getPlantForTime: function (hrs, mins) {
    IRWN.currentSceneIndex = this.getSceneForTime(hrs, mins);
    return this.getPlantFromIndex(IRWN.currentSceneIndex);
  },
  getPlantFromIndex: function (index) {
    // WARNING: make sure to update the getIndexFromPlant function whenever you edit these
    switch (index) {
      case 0: return "_1_ANTHER";
      case 1: return "_2_CONVO";
      case 2: return "_3_TRICHO";
      case 3: return "_4_ANA";
      case 4: return "_5_PETROR";
      case 5: return "_6_HYPO";
      case 6: return "_7_MALVA";
      case 7: return "_8_NYMPH";
      case 8: return "_9_MESEM";
      case 9: return "_10_CALEN";
      case 10: return "_11_HIERA";
      case 11: return "_12_HEMERO";
      case 12:
      default:
        return "_13_PAPA";
    }
  },
  getIndexFromPlant: function (plant) {
    // WARNING: make sure to update the getPlantFromIndex function whenever you edit these
    switch (plant) {
      case "_1_ANTHER": return 0;
      case "_2_CONVO": return 1;
      case "_3_TRICHO": return 2;
      case "_4_ANA": return 3;
      case "_5_PETROR": return 4;
      case "_6_HYPO": return 5;
      case "_7_MALVA": return 6;
      case "_8_NYMPH": return 7;
      case "_9_MESEM": return 8;
      case "_10_CALEN": return 9;
      case "_11_HIERA": return 10;
      case "_12_HEMERO": return 11;
      case "_13_PAPA": return 12;
      default: return null;
    }
  },

  uuidv4: function () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  },
  getDevicePixelRatio: function () {
    return 2;
    let mediaQuery;
    const is_firefox =
      navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    if (window.devicePixelRatio !== undefined && !is_firefox) {
      return window.devicePixelRatio;
    } else if (window.matchMedia) {
      mediaQuery =
        "(-webkit-min-device-pixel-ratio: 1.5),\
          (min--moz-device-pixel-ratio: 1.5),\
          (-o-min-device-pixel-ratio: 3/2),\
          (min-resolution: 1.5dppx)";
      if (window.matchMedia(mediaQuery).matches) {
        return 1.5;
      }
      mediaQuery =
        "(-webkit-min-device-pixel-ratio: 2),\
          (min--moz-device-pixel-ratio: 2),\
          (-o-min-device-pixel-ratio: 2/1),\
          (min-resolution: 2dppx)";
      if (window.matchMedia(mediaQuery).matches) {
        return 2;
      }
      mediaQuery =
        "(-webkit-min-device-pixel-ratio: 0.75),\
          (min--moz-device-pixel-ratio: 0.75),\
          (-o-min-device-pixel-ratio: 3/4),\
          (min-resolution: 0.75dppx)";
      if (window.matchMedia(mediaQuery).matches) {
        return 0.7;
      }
    } else {
      return 1;
    }
  },
  analyticsReport: function (action, label) {
    IRWN.axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: action,
      label: label,
    });
  },
};

IRWN.plantConfigs = {
  _1_ANTHER: {
    id: "_1_ANTHER",
    fullName: `Anthericum ramosum`,
    palette: 2,
    useDarkUI: true,
    index: 0,
  },
  _2_CONVO: {
    id: "_2_CONVO",
    fullName: `Convolvulus tricolor`,
    palette: 2,
    useDarkUI: true,
    index: 1,
  },
  _3_TRICHO: {
    id: "_3_TRICHO",
    fullName: `Trichodiadema babrata`,
    palette: 1,
    useDarkUI: true,
    index: 2,
  },
  _4_ANA: {
    id: "_4_ANA",
    fullName: `Anagallis arvensis`,
    palette: 1,
    useDarkUI: true,
    index: 3,
  },
  _5_PETROR: {
    id: "_5_PETROR",
    fullName: `Petrorhagia prolifera`,
    palette: 1,
    useDarkUI: false,
    index: 4,
  },
  _6_HYPO: {
    id: "_6_HYPO",
    fullName: `Hypochaeris glabra`,
    palette: 3,
    useDarkUI: true,
    index: 5,
  },
  _7_MALVA: {
    id: "_7_MALVA",
    fullName: `Malva caroliniana`,
    palette: 1,
    useDarkUI: true,
    index: 6,
  },
  _8_NYMPH: {
    id: "_8_NYMPH",
    fullName: "Nymphaea alba",
    palette: 0,
    useDarkUI: false,
    index: 7,
  },
  _9_MESEM: {
    id: "_9_MESEM",
    fullName: `Mesembryanthemum crystallinum`,
    palette: 3,
    useDarkUI: true,
    index: 8,
  },
  _10_CALEN: {
    id: "_10_CALEN",
    fullName: `Calendula officinalis`,
    palette: 3,
    useDarkUI: true,
    index: 9,
  },
  _11_HIERA: {
    id: "_11_HIERA",
    fullName: `Hieracium aurantiacum`,
    palette: 3,
    useDarkUI: false,
    index: 10,
  },
  _12_HEMERO: {
    id: "_12_HEMERO",
    fullName: `Hemerocallis lilioasphodelus`,
    palette: 3,
    useDarkUI: false,
    index: 11,
  },
  _13_PAPA: {
    id: "_13_PAPA",
    fullName: `Papaver nudicaule`,
    palette: 0,
    useDarkUI: false,
    index: 12,
  },
};

IRWN.palettes = [
  {
    neutral: { r: 0.77254902, g: 0.67843137, b: 0.69411765 },
    hover: { r: 0.68627451, g: 0.49803922, b: 0.5372549 },
    active: { r: 0.84313725, g: 0.75686275, b: 0.77647059 },
  },
  {
    neutral: { r: 0.3254902, g: 0.16078431, b: 0.19215686 },
    hover: { r: 0.37254902, g: 0.09411765, b: 0.14117647 },
    active: { r: 0.52156863, g: 0.19215686, b: 0.24705882 },
  },
  {
    neutral: { r: 0.1372549, g: 0.27843137, b: 0.3254902 },
    hover: { r: 0.03921569, g: 0.17254902, b: 0.21960784 },
    active: { r: 0.18039216, g: 0.37647059, b: 0.44313725 },
  },
  {
    neutral: { r: 0.49803922, g: 0.57647059, b: 0.69411765 },
    hover: { r: 0.33333333, g: 0.43137255, b: 0.57254902 },
    active: { r: 0.57254902, g: 0.66666667, b: 0.80392157 },
  },
];
